// constants

const CLEAR_FOUR_D_PRIZE = "CLEAR_FOUR_D_PRIZE";
const SET_FOUR_D_PRIZE = "SET_FOUR_D_PRIZE";

// reducers

const initialState = {};

// prettier-ignore
const FourDPrize = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_FOUR_D_PRIZE:
      return {};

    case SET_FOUR_D_PRIZE:
      return { ...action.payload };

    default:
      return state;
  }
};

export default FourDPrize;

// actions

// const resolveAfter2Seconds = () => {
//   return new Promise((resolve) => {
//     setTimeout(() => {
//       resolve("resolved");
//     }, 2000);
//   });
// };

// export const testCounterDecrement = () => async (dispatch) => {
//   const result = await resolveAfter2Seconds();
//   console.log(result);
//   dispatch({
//     type: TEST_COUNTER_DECREMENT,
//   });
// };

export const clearFourDPrize = () => {
  return {
    type: CLEAR_FOUR_D_PRIZE,
  };
};

export const setFourDPrize = (payload) => {
  return {
    type: SET_FOUR_D_PRIZE,
    payload: payload,
  };
};
